<template>
  <div class="r-container">
    <BasePro v-if="!loading" :detail="detail"></BasePro>
    <FormTitle
      class="mt28"
      title="正文"
      subTitle="（填写亮点会极大的彰显你的案例品质，更容易得到客户关注！）"
    ></FormTitle>
    <CustomEdit
      v-if="!loading"
      @on-delete="handleDelete"
      @on-prev="handleSortPrev"
      @on-next="handleSortNext"
      :materials="detail.materials"
    ></CustomEdit>
    <div class="add-widget">
      <el-button
        @click="handleAddSmailTitle"
        class="widget-button"
        icon="el-icon-circle-plus-outline"
        plain
        >添加小标题</el-button
      >
      <el-button
        @click="handleAddDescribe"
        class="widget-button"
        icon="el-icon-circle-plus-outline"
        plain
        >添加正文</el-button
      >
      <el-button class="widget-button" icon="el-icon-circle-plus-outline" plain>
        添加图片/视频
        <Upload
          class="position-abs"
          clean
          @on-success="handleUploadSuccess"
        ></Upload>
      </el-button>
    </div>

    <div class="flex-right" v-if="hasWxa">
      <el-select class="publish-target" v-model="detail.publishTarget">
        <el-option label="同时发布到APP和小程序" :value="1"></el-option>
        <el-option label="仅发布到app" :value="2"></el-option>
        <el-option label="仅发布到小程序" :value="3"></el-option>
      </el-select>
    </div>
    <FixedFooter class="custom-footer" :detail="detail">
      <el-button type="primary" plain @click="handlePreview">预览</el-button>
      <el-button type="primary" plain @click="handleSaveToDraft(false)"
        >保存到草稿箱</el-button
      >
      <el-button type="primary" @click="handlePublished">发布</el-button>
    </FixedFooter>

    <!-- 预览 -->
    <MobileBox
      :title="detail.title"
      append-to-body
      v-if="showPreview"
      :visible.sync="showPreview"
    >
      <Preview
        :caseData="detail"
        :user="{ name: name, avatar: avatar }"
      ></Preview>
    </MobileBox>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BasePro from "@/components/BasePro";
import FormTitle from "@/components/FormTitle";
import Preview from "@/components/Preview";
import CustomEdit from "@/components/CustomEdit";
import Upload from "@/components/Upload";
import FixedFooter from "@/components/FixedFooter";
import MobileBox from "@/components/MobileBox";
import {
  fetchCustomDraftEditData,
  fetchCustomEditData,
  fetchPublish,
  fetchSaveDraft,
} from "@/api";
import { uuid, swapArray } from "@/utils";
import { customDefault } from "@/const/defautDraft";
let timer;
let isInitial = true;
let datenow;
export default {
  name: "custom",
  provide() {
    return {
      editControl: this,
    };
  },
  computed: {
    ...mapGetters("user", { name: "name", avatar: "avatar", hasWxa: "hasWxa" }),
  },
  data: () => ({
    detail: customDefault(),
    loading: true,
    showPreview: false,
  }),
  watch: {
    detail: {
      handler: function () {
        if (!isInitial) {
          clearTimeout(timer);
          timer = setTimeout(() => {
            this.handleSaveToDraft(true);
          }, 1000);
        }
        isInitial = false;
      },
      immediate: true,
      deep: true,
    },
  },
  components: {
    BasePro,
    FormTitle,
    Upload,
    FixedFooter,
    CustomEdit,
    Preview,
    MobileBox,
  },
  created() {
    const { draftId = 0, projectId = 0 } = this.$route.query;
    Object.assign(this.detail, { draftId, projectId });
    if (projectId) {
      this.getCustomEditData(projectId);
    } else if (draftId) {
      this.getDraftData(draftId);
    } else {
      this.loading = false;
    }
  },
  methods: {
    handleDelete(index) {
      this.detail.materials.splice(index, 1);
    },
    handleSortPrev(index) {
      swapArray(this.detail.materials, index, index - 1);
    },
    handleSortNext(index) {
      swapArray(this.detail.materials, index, index + 1);
    },
    handleAddSmailTitle() {
      this.detail.materials.push({
        _id: uuid(),
        mediaType: 4,
        content: "",
      });
    },
    handleAddDescribe() {
      this.detail.materials.push({
        _id: uuid(),
        mediaType: 3,
        content: "",
      });
    },
    getDraftData(draftId) {
      fetchCustomDraftEditData(draftId).then((res) => {
        this.detail = res.data;
        this.loading = false;
      });
    },
    getCustomEditData(projectId) {
      fetchCustomEditData(projectId).then((res) => {
        this.detail = res.data;
        this.detail.draftId = 0;
        this.loading = false;
      });
    },
    handleUploadSuccess(file) {
      const [type] = file.type.split("/");
      let mediaType = "";
      if (type === "image") {
        mediaType = 1;
      } else if (type === "video") {
        mediaType = 2;
      }
      this.detail.materials.push({
        _id: uuid(),
        mediaType: mediaType,
        cover:
          type === "video"
            ? file.originalUrl + "?vframe/jpg/offset/1"
            : file.originalUrl,
        imgInfo: file,
      });
    },
    handleCoverUploadSuccess(data) {
      let json = {};
      try {
        json = JSON.parse(data);
      } catch (err) {
        json = {};
      }
      this.detail.cover = json;
    },
    handlePreview() {
      this.showPreview = true;
    },
    handleSaveToDraft(isAuto) {
      console.log("提交数据2", JSON.stringify(this.detail));
      fetchSaveDraft(this.detail).then((res) => {
        const { draftId } = res.data;
        this.detail.draftId = draftId;
        const { draftId: _id = 0 } = this.$route.query;
        // 记录滚动位置
        this.$route.meta.y = window.pageYOffset
        if (!_id) {
          this.$router.replace({
            query: {
              draftId: draftId,
            },
          });
        }
        if (!datenow || +new Date() - datenow >= 60000 || !isAuto) {
          datenow = +new Date();
          this.$message.success({
            showClose: true,
            message: isAuto ? "自动保存成功" : "保存成功",
          });
        }
      });
    },
    handlePublished() {
      const { projectId, draftId } = this.detail;
      fetchPublish({
        projectId,
        draftId,
      }).then(() => {
        this.$message.success("发布成功");
        this.$router.push("/published");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mt28 {
  margin-top: 28px;
}
.mt50 {
  margin-top: 50px;
}

.r-container {
  margin: 40px auto 80px auto;
  width: 940px;
  padding: 30px;
  .add-widget {
    display: flex;
    justify-content: space-around;
    height: 60px;
    .widget-button {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .position-abs {
        position: absolute;
        width: 100%;
        height: 58px;
        left: 0;
        top: 0;
      }
    }
  }
  .custom-footer {
    margin-left: -80px;
  }

  .flex-right {
    display: flex;
    justify-content: flex-end;
    .publish-target {
      width: 200px;
      margin-top: 20px;
    }
  }
}
</style>